const financialTypes = {
	BALANCE: {
		REQUEST: 'FINANCIAL_BALANCE_REQUEST',
		SUCCESS: 'FINANCIAL_BALANCE_SUCCESS',
		FAILURE: 'FINANCIAL_BALANCE_FAILURE',
	},
	BALANCE_DETAILS: {
		REQUEST: 'FINANCIAL_BALANCE_DETAILS_REQUEST',
		SUCCESS: 'FINANCIAL_BALANCE_DETAILS_SUCCESS',
		FAILURE: 'FINANCIAL_BALANCE_DETAILS_FAILURE',
	},

	VERIFY_PAYMENT: {
		REQUEST: 'FINANCIAL_VERIFY_PAYMENT_REQUEST',
		SUCCESS: 'FINANCIAL_VERIFY_PAYMENT_SUCCESS',
		FAILURE: 'FINANCIAL_VERIFY_PAYMENT_FAILURE',
	},

	PAYMENT_REQUEST: {
		REQUEST: 'FINANCIAL_PAYMENT_REQUEST_REQUEST',
		SUCCESS: 'FINANCIAL_PAYMENT_REQUEST_SUCCESS',
		FAILURE: 'FINANCIAL_PAYMENT_REQUEST_FAILURE',
	},

	PAYMENT_HISTORY_LIST: {
		REQUEST: 'FINANCIAL_PAYMENT_HISTORY_LIST_REQUEST',
		SUCCESS: 'FINANCIAL_PAYMENT_HISTORY_LIST_SUCCESS',
		FAILURE: 'FINANCIAL_PAYMENT_HISTORY_LIST_FAILURE',
	},

	PAYMENT_REQUEST_DETAILS: {
		REQUEST: 'FINANCIAL_PAYMENT_REQUEST_DETAILS_REQUEST',
		SUCCESS: 'FINANCIAL_PAYMENT_REQUEST_DETAILS_SUCCESS',
		FAILURE: 'FINANCIAL_PAYMENT_REQUEST_DETAILS_FAILURE',
	},

	TRANSACTIONS: {
		REQUEST: 'FINANCIAL_TRANSACTIONS_REQUEST',
		SUCCESS: 'FINANCIAL_TRANSACTIONS_SUCCESS',
		FAILURE: 'FINANCIAL_TRANSACTIONS_FAILURE',
	},

	INQUIRY_SHEBA: {
		REQUEST: 'INQUIRY_SHEBA_REQUEST',
		SUCCESS: 'INQUIRY_SHEBA_SUCCESS',
		FAILURE: 'INQUIRY_SHEBA_FAILURE',
	},
};

export default financialTypes;
